import { useSuggestion } from '@cobliteam/hooks/src/useSuggestion';
import { useTranslation } from '@cobliteam/i18n';
import Tag from '@cobliteam/ui/components/Tag';
import Icon from '@cobliteam/ui/icons';
import CobliConectaSuggestionSlide from '../CobliConectaSuggestion/CobliConectaSuggestionSlide';
import { useShouldShowCobliConecta } from '../CobliConectaSuggestion/useShouldShowCobliConecta';

const COBLI_CONECTA_SUGGESTION_ID = 'cobli-conecta-download';

/**
 * AE-2574 removed the basic-value recommendation slides, leaving suggestions as the card's only
 * content — hence no carousel. Level-2 group/place recommendations stay on their in-page banners.
 */
const AiRecommendationFloatingCard = () => {
  const { t } = useTranslation('app-header');
  const { t: tSuggestions } = useTranslation('suggestions');

  const { shouldShow: shouldShowCobliConecta, dismiss: dismissCobliConecta, accept: acceptCobliConecta } = useSuggestion(COBLI_CONECTA_SUGGESTION_ID, useShouldShowCobliConecta);

  if (!shouldShowCobliConecta) return null;

  return (
    <div className='fixed bottom-4 left-[calc(var(--sidebar-width-icon)+1rem)] z-[1003] w-fit max-w-[360px]'>
      <div className='flex w-full flex-col gap-[9px] rounded-2xl border border-[#d9d9e0] border-solid bg-[#fcfdfe] p-[14px] shadow-[0_4px_6px_-2px_rgba(0,0,0,0.05),0_10px_15px_-3px_rgba(0,0,0,0.1)]'>
        <div className='flex w-full items-center justify-between'>
          <Tag variant='surface' color='primary' size='sm' label={tSuggestions('cobli_conecta.tag_label')} icon={<Icon name='lightbulb' size='xs' />} />
          <button
            type='button'
            onClick={() => dismissCobliConecta()}
            aria-label={t('aiRecommendations.close')}
            className='flex size-6 items-center justify-center rounded-lg text-[#737373] transition-colors hover:bg-neutral-100'
          >
            <Icon name='x' size='sm' />
          </button>
        </div>

        <CobliConectaSuggestionSlide onAccept={acceptCobliConecta} onDismiss={dismissCobliConecta} />
      </div>
    </div>
  );
};

export default AiRecommendationFloatingCard;
